import { Button } from '@material-tailwind/react';
import CalendarImg from '../assets/img/calendar.svg';
import UpRightImg from '../assets/img/up_right.svg';
import RightImg from '../assets/img/right.svg'
import ClipboardImg from '../assets/img/clipboard.svg'
import { reducedAddress, copyText } from '../utils/utils';
import { useNavigate } from 'react-router-dom';

export default function TransactionComponent(props) {
    const { item } = props;
    const navigate = useNavigate()
    const goClaim = () => navigate(`/claim?id=${item.id}`)

    return (
        <div className='bg-[#121212] w-full px-4 sm:px-[20px] lg:px-[140px] pb-[12px] sm:pb-[16px]'>
            <div className='xl:hidden w-full bg-[#1B1B1B] rounded-[16px] px-4 py-4'>
                <div className='flex items-start justify-between gap-3'>
                    <div className='flex items-center min-w-0'>
                        <img src={item.date.icon} alt='ico' className='w-8 h-8 shrink-0' />
                        <div className='ml-3 min-w-0'>
                            <p className='text-white text-[15px] font-medium'>{item.date.symbol}</p>
                            <p className='text-[#86888C] text-[13px] truncate'>{item.date.chain}</p>
                        </div>
                    </div>
                    <Button className='w-[36px] h-[36px] bg-transparent p-0 rounded-full shrink-0' onClick={goClaim}>
                        <img src={RightImg} alt='open' />
                    </Button>
                </div>
                <div className='mt-4 grid grid-cols-2 gap-3 text-[13px]'>
                    <div>
                        <p className='text-[#86888C] uppercase'>Type</p>
                        <div className='flex items-center mt-1'>
                            <img src={item.type.icon} alt='type' className='w-4 h-4' />
                            <span className='text-white ml-2'>{item.type.value}</span>
                        </div>
                    </div>
                    <div>
                        <p className='text-[#86888C] uppercase'>Timing end</p>
                        <div className='flex items-center mt-1'>
                            <img src={CalendarImg} alt='date' className='w-4 h-4' />
                            <span className='text-white ml-2'>{item.timeEnd}</span>
                        </div>
                    </div>
                    <div>
                        <p className='text-[#86888C] uppercase'>Name & value</p>
                        <p className='text-white mt-1'>{item.totalValue.name}</p>
                        <p className='text-[#86888C]'>{item.totalValue.value}</p>
                    </div>
                    <div>
                        <p className='text-[#86888C] uppercase'>Heir</p>
                        <p className='text-white mt-1 break-all'>{reducedAddress(item.address.address)}</p>
                    </div>
                </div>
                <div className='flex items-center justify-between mt-4 pt-3 border-t border-[#2C2C2C]'>
                    <p className='text-white text-[13px]'>TxID: {reducedAddress(item.transaction)}</p>
                    <Button
                        className='w-[38px] h-[40px] rounded-[6px] border border-[#2C2C2C] flex items-center justify-center p-[12px]'
                        onClick={() => copyText(item.transaction)}
                    >
                        <img src={ClipboardImg} className='w-[13px] h-[16px]' alt='copy' />
                    </Button>
                </div>
            </div>

            <div className='hidden xl:flex flex-row items-center justify-between w-full bg-[#1B1B1B] rounded-[16px] px-[40px] py-[20px]'>
                <div className='flex flex-row basis-2/12'>
                    <img src={item.date.icon} alt='ico' />
                    <div className='flex flex-col ml-[12px]'>
                        <p className='font-Inter-Regular text-[16px] text-[#FFF] font-medium'>
                            {item.date.symbol}
                        </p>
                        <p className='font-Inter-Regular text-[14px] text-[#86888C]'>
                            {item.date.chain}
                        </p>
                    </div>
                </div>

                <div className='flex flex-row items-center basis-1/12'>
                    <img src={item.type.icon} alt='ico' />
                    <p className='font-Inter-Regular text-[16px] text-[#FFF] font-medium ml-[12px]'>
                        {item.type.value}
                    </p>
                </div>

                <div className='flex flex-row items-center basis-1/12'>
                    <img src={CalendarImg} alt='ico' />
                    <p className='font-Inter-Regular text-[16px] text-[#FFF] font-medium ml-[12px]'>
                        {item.timeEnd}
                    </p>
                </div>

                <div className='flex flex-col basis-2/12'>
                    <p className='font-Inter-Regular text-[14px] text-[#86888C] font-bold'>
                        {item.totalValue.name}
                    </p>
                    <p className='font-Inter-Regular text-[14px] text-[#86888C]'>
                        {item.totalValue.value}
                    </p>
                </div>

                <div className='flex flex-row items-center basis-2/12'>
                    <img src={item.address.icon} alt='ico' />
                    <p className='font-Inter-Regular text-[16px] text-[#FFF] font-medium ml-[12px]'>
                        {reducedAddress(item.address.address)}
                    </p>
                </div>
                <div className='flex flex-row h-full items-center justify-between basis-3/12'>
                    <div className='flex flex-row '>
                        <p className='font-Inter-Regular text-[16px] text-[#FFF] font-medium mr-[6px]'>
                            TxID: {reducedAddress(item.transaction)}
                        </p>
                        <img src={UpRightImg} alt='ico' />
                    </div>

                    <Button
                        className='w-[38px] h-[40px] rounded-[6px] border-[1px] border-[#2C2C2C] flex items-center justify-center p-[12px]'
                        onClick={() => copyText(item.transaction)}
                    >
                        <img src={ClipboardImg} className='w-[13px] h-[16px]' alt='ico' />
                    </Button>
                    <div className='w-[1px] h-[64px] bg-[#2C2C2C]'></div>
                    <Button className='w-[36px] h-[36px] bg-transparent p-0 rounded-full' onClick={goClaim}>
                        <img src={RightImg} alt='ico' />
                    </Button>
                </div>
            </div>
        </div>
    )
}
